import React from 'react';
import Alert from 'react-bootstrap/Alert';
import ProgressBar from 'react-bootstrap/ProgressBar';

class AlertHandler extends React.Component {
  constructor(props) {
    super(props);
  
    this.tempLoadingCount = 0;
    this.state = {
      alert: null,
      loadingCount: 0,
      userAlert: undefined,
      hideProgressBar: true
    };
    
    radio("showAlert").subscribe(this.showAlert.bind(this));
    radio("showLoader").subscribe(this.showLoader.bind(this));
    radio("hideLoader").subscribe(this.hideLoader.bind(this));
  }
  
  showAlert(style, message) {
    this.setState({
      alert: {style: style, message: message}
    });
  }

  showLoader() {
    this.setState({
      hideProgressBar: false,
      loadingCount: this.state.loadingCount + 1
    });
  }

  hideLoader() {
    this.setState({
      loadingCount: this.state.loadingCount > 0 ? this.state.loadingCount - 1 : 0
    });
  }

  getClass() {
    return "alert-handler";
  }

  dismissAlert() {
    this.setState({
      alert: null
    })
  }

  getAlert() {
    if (this.state.alert) {
      return (<Alert
        transition={false}
        variant={this.state.alert.style}
        dismissible
        onClose={this.dismissAlert.bind(this)}
      >
        <p>{this.state.alert.message}</p>
      </Alert>)
    }
  }

  getLoader() {
    if (this.state.hideProgressBar) {
      return undefined;
    }
    if (this.state.loadingCount > 0) {
      this.tempLoadingCount = this.state.loadingCount;
      return <ProgressBar striped variant='info' now={15}/>
    } else {
      if (this.tempLoadingCount > 0) {
        this.tempLoadingCount = 0;
        setTimeout(() =>this.setState({
          hideProgressBar: true
        }), 500);
        return <ProgressBar striped variant='info' now={100}/>
      }
    }
  }

  dismissUserAlert() {
    this.setState({
      userAlert: undefined
    });
  }

  getUserAlert() {
    if (this.state && this.state.userAlert) {
      let icon = "icon-" + this.state.userAlert.alertType;
      switch(this.state.userAlert.alertType) {
        case "warning":
          icon = "icon-alert";
          break;
      }
      let headerClass = "user-alert-header user-alert-header-" + this.state.userAlert.alertType;
      return <div className="user-alert-container">
        <div className={headerClass}>
          <div className={"user-alert-icon type-" + this.state.userAlert.alertType}>
            <i className={icon}/>
          </div>
          Please Note
          <i className="icon-cross" onClick={this.dismissUserAlert.bind(this)}/>
        </div>
        <div dangerouslySetInnerHTML={{__html: this.state.userAlert.htmlMessage }}/>
      </div>
    }
  }

  render() {
    return (<div>
      <div className={this.getClass()}>
        { this.getLoader() }
        { this.getAlert() }
        { this.getUserAlert() }
      </div>
    </div>);
  }
}

module.exports = {
  AlertHandler: AlertHandler
}
